import sharingFee from './sharing-fee'
import adminFee from './admin-fee'
import invoiceAdmin from './invoice-admin'
import invoiceTalent from './invoice-talent'

export default [...sharingFee, ...adminFee, ...invoiceAdmin, ...invoiceTalent]
